const state = {
  themeId: 0,
  filterApiUrl: 'https://services.mybcapps.com/bc-sf-filter/filter',
  searchApiUrl: 'https://services.mybcapps.com/bc-sf-filter/search',
  suggestApiUrl: 'https://services.mybcapps.com/bc-sf-filter/search/suggest',
  _preloadedImages: [],
  showNewsletterPopup: false,
}

const mutations = {
  initConfig(state, vars) {
    Object.keys(vars).forEach(k => {
      state[k] = vars[k]
    });
  },
  preloadImages(state, { images, high_priority }) {
    if (high_priority) {
      state._preloadedImages = images.concat(state._preloadedImages)
    } else {
      state._preloadedImages = state._preloadedImages.concat(images)
    }
    // Remove duplicates
    state._preloadedImages = [...new Set(state._preloadedImages)];
  },
  setNewsletterPopup(state, val) {
    state.showNewsletterPopup = val
  },
  _resetPreloadedImages(state) {
    state._preloadedImages = []
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}